import {Alert, Snackbar,} from "@mui/material";
import React, {useState} from "react";
import SearchIcon from "@mui/icons-material/Search";
import SearchRefreshIcon from '@mui/icons-material/YoutubeSearchedFor';
const Message = React.memo(MessageBase);
function MessageBase({handleClose, open, message}) {
    const isSuccess = message.searchRefresh && message.message !== "No new items";
    const isRefresh = isSuccess || message.message === "No new items";
    const additional = message.additional;
    const [isAdditionalOpen, setIsAdditionalOpen] = useState(false);
    return (<>
        <Snackbar key={message ? message.key : undefined} className={"SnackBar"} anchorOrigin={{
            vertical: 'top',
            horizontal: 'center'
        }} open={open} autoHideDuration={additional ? undefined : isRefresh ? 4000 : 6000} onClose={handleClose}>
            <Alert onClose={handleClose}
                   icon={message.search ? <SearchIcon/> : message.searchRefresh ? <SearchRefreshIcon/> : undefined}
                   severity={(isSuccess ? "success" : message.severity)} sx={{width: '100%'}}>
                <span style={{cursor: additional ? "pointer" : undefined}} onClick={additional ? ()=>setIsAdditionalOpen(prev=>!prev) : undefined}>
                {message.message ?? ""}
                </span>
                {
                    isAdditionalOpen && <>
                    <br/><br/>
                        {additional}
                    </>
                }
            </Alert>
        </Snackbar>
    </>)
}
export default Message;